import * as React from 'react';
import { Input, Modal } from 'antd';

import Form, { FormItem } from '../../../../../../components/Form';

export interface ICountryStateDetailProps {
  countryState: GQL.ICountryState;
  onSave: (countryState: GQL.ICountryState) => void;
  onCancel: () => void;
}

export interface ICountryStateDetailState {
  countryState: GQL.ICountryState;
}

export default class CountryStateDetail extends React.Component<ICountryStateDetailProps, ICountryStateDetailState> {

  constructor(props: ICountryStateDetailProps) {
    super(props);

    this.state = {
      countryState: {...props.countryState},
    };

    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);
  }

  public render() {
    const { countryState } = this.state;

    return (
      <Modal
        maskClosable={false}
        style={{ top: '5vh' }}
        // width={'40%'}
        title={`Country state ${countryState.name ? `"${countryState.name}"` : ``}`}
        visible={true}
        footer={null}
        onCancel={() => this.props.onCancel()}
      >
          <Form 
            onSubmit={this.save}
            onCancel={() => this.props.onCancel()}
          >
            <FormItem label="Name" required={true}>
              <Input
                name={'name'}
                autoFocus={true}
                required={true}
                placeholder="State name"
                value={countryState.name}
                onChange={this.onChange}
              />
            </FormItem>
            <FormItem label={`Vat rate`}>
              <Input
                name={'vatRate'}
                type={'number'}
                placeholder={`Vat rate`}
                addonAfter={'%'}
                value={countryState.vatRate}
                onChange={(e: any) => this.onChange({ target: { name: e.target.name, value: parseFloat(e.target.value) || null } })}
              />
            </FormItem>
          </Form>
      </Modal>
    );
  }

  private onChange(e: any, language?: string) {
    const { name, value, checked } = e.target;

    const inputValue = (value !== undefined ? value : checked);

    const newValue = (language
      ? { [name]: { ...this.state.countryState[name], [language]: inputValue } }
      : { [name]: inputValue });

    this.setState({
      countryState: { ...this.state.countryState, ...newValue }
    });
  }

  private save() {
    const countryState = {...this.state.countryState};

    countryState.title = {
      'en': countryState.name,
      'cs': countryState.name,
    };

    this.props.onSave(countryState);
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Countries/CountryDetail/components/CountryStates/components/CountryStateDetail.tsx